import api from "../../../../../../api/api";

export const getAIGeneratedCourses = async (token) => {
  const payload = {};
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Token ${token}`,
  };
  try {
    const response = await api.post(
      `courses/generate-personalized-courses/`,
      payload,
      { headers },
    );
    if (response.status === 200 || response.status === 201) {
      return { courses: response.data?.courses, teacherId: response.data?.teacher_id };
    }
  } catch (error) {
    console.log(error);
  }
};
export const getAIGeneratedLessons = async (token, courseId, teacherId) => {
  const payload = {
    teacher: teacherId,
    lesson_count: 3,
    status: 1,
    auto_generate: true,
    is_personalize: false,
  };
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Token ${token}`,
  };
  try {
    const response = await api.post(
      `courses/${courseId}/create-lessons/`,
      payload,
      { headers },
    );
    if (response.status === 200 || response.status === 201) {
      // console.log("AI Generated Lessons:", response.data, response);
      return
    }
  } catch (error) {
    console.log(error);
  }
};
